// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.obras-page {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

.filter-buttons {
    display: flex;
    gap: 10px;
}

.filter-btn {
    padding: 8px 16px;
    border: 1px solid #ddd;
    background: white;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    transition: all 0.2s;
}

.filter-btn:hover {
    border-color: #667eea;
}

.filter-btn.active {
    background: #667eea;
    color: white;
    border-color: #667eea;
}

/* Obras Grid matching Maquetes Dashboard */
.obras-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.obra-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 1px solid transparent;
}

.obra-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-header .posicao {
    font-weight: bold;
    color: #4a5568;
    font-size: 1.1em;
}

.status-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
}

.status-planned {
    background: #fef3c7;
    color: #92400e;
}

.status-active {
    background: #d1fae5;
    color: #065f46;
}

.status-completed {
    background: #dbeafe;
    color: #1e40af;
}

.status-suspended {
    background: #fee2e2;
    color: #991b1b;
}

.card-body h4 {
    margin: 0 0 5px 0;
    color: #2d3748;
    font-size: 0.95rem;
    font-weight: 600;
}

.card-body p {
    margin: 0;
    font-size: 0.9rem;
    color: #718096;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.obra-footer {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-top: 1px solid #edf2f7;
    padding-top: 15px;
}

.obra-actions {
    display: flex;
    gap: 10px;
}

.action-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    color: #3182ce;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s;
}

.action-btn:hover {
    background: #ebf8ff;
    border-color: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(49, 130, 206, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/pages/Obras.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;AACzB;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD","sourcesContent":[".obras-page {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100%;\r\n}\r\n\r\n.filter-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.filter-btn {\r\n    padding: 8px 16px;\r\n    border: 1px solid #ddd;\r\n    background: white;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 0.85rem;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.filter-btn:hover {\r\n    border-color: #667eea;\r\n}\r\n\r\n.filter-btn.active {\r\n    background: #667eea;\r\n    color: white;\r\n    border-color: #667eea;\r\n}\r\n\r\n/* Obras Grid matching Maquetes Dashboard */\r\n.obras-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n    gap: 20px;\r\n}\r\n\r\n.obra-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.obra-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\r\n    border-color: #4299e1;\r\n}\r\n\r\n.card-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.card-header .posicao {\r\n    font-weight: bold;\r\n    color: #4a5568;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.status-badge {\r\n    padding: 4px 10px;\r\n    border-radius: 20px;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.status-planned {\r\n    background: #fef3c7;\r\n    color: #92400e;\r\n}\r\n\r\n.status-active {\r\n    background: #d1fae5;\r\n    color: #065f46;\r\n}\r\n\r\n.status-completed {\r\n    background: #dbeafe;\r\n    color: #1e40af;\r\n}\r\n\r\n.status-suspended {\r\n    background: #fee2e2;\r\n    color: #991b1b;\r\n}\r\n\r\n.card-body h4 {\r\n    margin: 0 0 5px 0;\r\n    color: #2d3748;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.card-body p {\r\n    margin: 0;\r\n    font-size: 0.9rem;\r\n    color: #718096;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n}\r\n\r\n.obra-footer {\r\n    margin-top: auto;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    border-top: 1px solid #edf2f7;\r\n    padding-top: 15px;\r\n}\r\n\r\n.obra-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.action-btn {\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: #f1f5f9;\r\n    color: #3182ce;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.action-btn:hover {\r\n    background: #ebf8ff;\r\n    border-color: #3182ce;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 6px rgba(49, 130, 206, 0.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
